import {
  GET_CYCLEWALL_REPORT,
  GET_CYCLEWALL_REPORT_ERROR,
  GET_CYCLEWALL_REPORT_SUCCESS,
} from './CyclesWalls.actions';

const initialState = {
  data: [],
  loading: false,
  error: undefined,
};

/**
 * The CycleWall Reducer.
 */
const cycleWallReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case GET_CYCLEWALL_REPORT: {
      return { ...state, loading: true, error: undefined }; // Set loading to true
    }
    case GET_CYCLEWALL_REPORT_ERROR: {
      return { ...state, loading: false, error: payload.error }; // Set error and loading to false
    }
    case GET_CYCLEWALL_REPORT_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: undefined,
        data: payload.data, // Save the data to the state
      };
    }
    default: {
      return state; // Default case to return the unchanged state
    }
  }
};

export default cycleWallReducer;
